import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TInsightIcon } from './InsightIcon';
import { formatRate, formatCount, absoluteDifference } from '../../utils';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import Small from 'UIComponents/elements/Small';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SpotlightHeading({
  current,
  expected,
  insightType,
  context
}) {
  const difference = absoluteDifference(expected, current);
  const formattedDifference = formatCount(difference);
  if (context === 'BUSINESS_UNIT_CONTEXT') {
    return /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
      message: `messaging-insights.insights.spotlights.${insightType}.BUSINESS_UNIT_CONTEXT.heading`,
      rebrandMessage: `messaging-insights.insights.spotlights.${insightType}.BUSINESS_UNIT_CONTEXT.heading_buv2`,
      options: {
        difference: formattedDifference
      },
      "data-test-id": "spotlight-heading"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `messaging-insights.insights.spotlights.${insightType}.${context}.heading`,
    options: {
      difference: formattedDifference
    },
    "data-test-id": "spotlight-heading"
  });
}
export function SpotlightDescription({
  current,
  expected,
  insightType,
  context
}) {
  const formattedCurrentRate = formatRate(current);
  const formattedExpectedRate = formatRate(expected);
  if (context === 'BUSINESS_UNIT_CONTEXT') {
    return /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
      message: `messaging-insights.insights.spotlights.${insightType}.BUSINESS_UNIT_CONTEXT.description`,
      rebrandMessage: `messaging-insights.insights.spotlights.${insightType}.BUSINESS_UNIT_CONTEXT.description_buv2`,
      options: {
        current: formattedCurrentRate,
        expected: formattedExpectedRate
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `messaging-insights.insights.spotlights.${insightType}.${context}.description`,
    options: {
      current: formattedCurrentRate,
      expected: formattedExpectedRate
    }
  });
}
export function Spotlight({
  context,
  createdAt,
  current,
  expected,
  polarity,
  compact,
  insightType
}) {
  const heading = /*#__PURE__*/_jsx(SpotlightHeading, {
    current: current,
    expected: expected,
    context: context,
    insightType: insightType
  });
  const description = /*#__PURE__*/_jsx(SpotlightDescription, {
    current: current,
    expected: expected,
    context: context,
    insightType: insightType
  });
  const spacing = compact ? 'extra-small' : 'small';
  return /*#__PURE__*/_jsxs(UIMediaObject, {
    itemLeft: /*#__PURE__*/_jsx(TInsightIcon, {
      polarity: polarity,
      marginBlockStart: "100"
    }),
    spacing: spacing,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "align-center justify-between",
      children: [/*#__PURE__*/_jsx("strong", {
        children: heading
      }), createdAt && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "messaging-insights.insights.generatedOn",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: createdAt,
              format: "ll"
            }),
            time: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: createdAt,
              format: "LT"
            })
          }
        })
      })]
    }), description]
  });
}
function Spotlights(props) {
  const cardSectionClassName = props.compact ? 'p-all-4' : 'p-bottom-6 p-top-7';
  return /*#__PURE__*/_jsx(UICardWrapper, {
    compact: true,
    className: props.className,
    "data-test-id": "spotlight",
    children: /*#__PURE__*/_jsx(UICardSection, {
      className: cardSectionClassName,
      children: /*#__PURE__*/_jsx(Spotlight, Object.assign({}, props))
    })
  });
}
export default /*#__PURE__*/memo(Spotlights);